// Cart Notes
document.addEventListener("DOMContentLoaded", function(event) { 
  const cart_note_trigger = document.querySelector('.cart-ordernote-heading');

  if(cart_note_trigger) { 
    cart_note_trigger.addEventListener('click', event => {

      const cart_note = document.querySelector('.cart__note .cart__note-box');

      if (cart_note.style.display === "none") {
        cart_note.style.display = "block";
      } else {
        cart_note.style.display = "none";
      }

    });
  }
});